import {CreateOperationContent} from "./OperationContent";
import {HookUpContext} from "./ContentComponent";
import {Operation} from "./OperationBase";

export abstract class WebComponent extends HTMLElement {
  abstract render():any;
  load():void {}

  #OC:Operation;

  #Initialized:boolean=false;
  #PropValues:any;
  
  constructor() {
    super();
    HookUpContext(this);
    // we must grab any prop values set onto HTMLElement here - before object is converted to final component type
    if((<any>this.constructor).props) {
      this.#PropValues={};
      for(const name in (<any>this.constructor).props) {
        if(!(name in this)) continue;
        //console.debug("Getting prop '" + name + "' set-from-outside value = " + (<any>this)[name]);
        this.#PropValues[name]=(<any>this)[name];
      }
      for(const name in this.#PropValues) delete (<any>this)[name];
    }
  }
  
  connectedCallback() {
    if(this.#Initialized) return;

    // we must wait until here to setup props - because final component type not available in constructor
    // attributes will be set before this
    if((<any>this.constructor).props) {
      for(const name in (<any>this.constructor).props) {
        if(!(name in this.#PropValues) && name in this) {
          // Not provided from outside (=in #PropValues) but is in this.name now = default value or attribute value
          // console.debug("Getting prop '" + name + "' value = " + (<any>this)[name]);
          this.#PropValues[name]=(<any>this)[name];
        }
      }
      for(const name in this.#PropValues) delete (<any>this)[name];
      for(const name in (<any>this.constructor).props) {
        Object.defineProperty(this,name,{
          get: ()=>this.#PropValues[name],
          set: v=>{
            this.#PropValues[name]=v;
            if(this.#OC) this.$redraw(); // don't redraw if before first draw
          },
          configurable:false,
          enumerable:true
        });
      }
    }
    
    this.#Initialized=true;
    this.load();
    this.#OC=CreateOperationContent((newContent:Node)=>{
        this.innerHTML="";
        if(newContent) this.appendChild(newContent)
      },-1, this ,this.render());
  }

  #RedrawPromise:Promise<void>=null;
  $redraw():Promise<void> {
    if(!this.#Initialized) return Promise.resolve();
    if(this.#RedrawPromise==null) {
      this.#RedrawPromise=new Promise<void>((resolve,reject)=>{
        requestAnimationFrame(()=>{
          this.#RedrawPromise=null;
          try {
            this.#OC.Update(this.render())
            resolve();
            dispatchEvent(new Event("katla:redraw"));
          } catch(ex) {
            console.error(ex);
            reject(ex);
          }
        });
      });
    }
    return this.#RedrawPromise;
  }
  
  static get observedAttributes():string[] {
    if(!(<any>this).props) return [];
    let rv:string[]=[];
    for(const name in (<any>this).props) if((<any>this).props[name]) rv.push(name);
    return rv;
  };

  attributeChangedCallback(name:string, oldValue:string, newValue:string) {
    // console.debug("Atribute '" + name + "' changed from '" + oldValue + "' to '" + newValue +"'");
    (<any>this)[name] = typeof (<any>this.constructor).props[name] == "function" ? (<any>this.constructor).props[name](newValue) : newValue;
  }

}
